@if (lesson()){
  <div class="inner-section">

    @if(isShowModal() && lesson()?.isCompleted && lesson()?.isLastLessonInModule){
      <div class="modal-lesson">
        <confirmation-modal
          [typeImage]="'lastLesson'"
          [textModal]="'Модуль пройден.\nХотите ответить на вопросы для самопроверки?'">
          <div class="modal-lesson-buttons">
            <button
              (click)="goToCourses()"
              class="button">Пропустить</button>
            <button
              (click)="goToTest()"
              class="button active">Перейти</button>
          </div>
        </confirmation-modal>
      </div>
}

    @if(isInformModal()){
      <div (click)="closeInfoModal()" >
      <information-modal [textModal]="titleInformModal"
      [closeModal]="closeInfoModal">
      </information-modal>
        </div>
    }

    <div class="lesson-page">
      <div class="back">
        <back-button>
        </back-button>
      </div>

      <div class="lesson-block">
        <div class="video-inner">
          <div class="video-wrapper">
            <h1 class="title din-pro-condensed">
              {{lesson()?.title}}
            </h1>
            @if(videoUrl()){
            <div class="video-container">
                <iframe
                  [src]="videoUrl()"
                  title="Lesson Video"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen>
                </iframe>
            </div>
          } @else{
              <div class="video-not">
                <span class="din-pro-bold black-color">Видео недоступно!</span>
              </div>
        }
          </div>
        </div>
        <div class="controls">
          <div class="custom-arrows custom-arrow-background">
            <button
              class="arrow prev swiper-prev swiper-button-prev"
              [class.disabled]="!lesson()?.previousLessonId"
              [disabled]="!lesson()?.previousLessonId"
              (click)="goToLesson(lesson()!.previousLessonId)">
            </button>
            @if (lesson()?.isCompleted) {
              <div class="completed-wrapper">
                <div class="completed-text din-pro-condensed">
                  ВЫ ПРОШЛИ ЛЕКЦИЮ
                  <img class="course-icon arrow-dropdown" src="../../../assets/icons/success.svg">
                </div>
              </div>
            } @else if (!lesson()?.isCompleted){
              <button
                class="button active button-with-check-right din-pro-condensed"
                (click)="lesson()?.id && completeLection(lesson()!.id)">
                Лекция пройдена
              </button>
            }
              <button
                class="arrow next swiper-next swiper-button-next"
                [class.disabled]="!lesson()?.nextLessonId || !lesson()?.isCompleted"
                [disabled]="!lesson()?.nextLessonId || !lesson()?.isCompleted"
                (click)="goToLesson(lesson()!.nextLessonId)">
              </button>
          </div>
        </div>
      </div>

      <div class="description">
        <div class="description-header">
          <div (click)="isOpen.set(!this.isOpen())" [class.active-module]="isOpen()" class="module-item-wrap">
            <p class="module-item-title din-pro-condensed">ОПИСАНИЕ</p>
            <img class="course-icon arrow-dropdown" [class.arrow-down]="!isOpen()" src="../../../assets/icons/arrow.svg">
          </div>
        </div>
        @if (isOpen()) {
          <div [innerHTML]="lesson()?.description" class="description-content din-pro-simple-text ">
          </div>
        }
      </div>
    </div>
  </div>
}
